import React from 'react'
import '../../gobalStyles/globalCssVariables.css'

const TextInput = () => (
  <div>
    <input type="text" name="password" placeholder="johndoe@gmail.com" />
  </div>
)

export default TextInput
